import {get, maxBy, nthArg, createSelector, sortBy, groupBy, keyBy, mapValues, has, partition} from 'helpers';
import {RootState} from 'store/root-state.type';

export const units = createSelector(
  (state: RootState) => state.units,
  (units) => {
    let [predefined, custom] = partition(units, (unit) => unit.isDefault);
    predefined = groupBy(predefined, 'category');
    predefined = mapValues(predefined, (units, name) => ({name, units}));
    predefined = sortBy(predefined, 'units.[0].orderIndex');
    const names = keyBy(units, unit => unit.name && unit.name.toLowerCase().trim())
    const maxOrderIndex = maxBy(custom, 'orderIndex')?.orderIndex ?? 1001;
    return {predefined, custom, names, units, maxOrderIndex};
  }
);

export const getByName = createSelector(
  units,
  units => (name?: string) => name && units.names[name.toLowerCase().trim()] || undefined,
);

export const getById = createSelector(
  units,
  ({units}) => (id?: string | number) => id && units[id] || undefined,
);
